import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_ITEM_FAVORITING } = interactionTypeConstants;
const {
    STEP_INTERACTION_NUDGE_DISPLAYED,
    STEP_INTERACTION_NUDGE_DISMISSED,
    STEP_INTERACTION_NUDGE_CLICKED,
} = stepInteractionConstants;

type ItemFavoritingNudgeTrigger =
    | 'pdp longview'
    | 'sb longview'
    | 'repeat pdp view'
    | 'first pdp view'
    | 'first sb view';

function trackFavoritingNudgeDisplayed({ trigger }: { trigger: ItemFavoritingNudgeTrigger }): void {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
        step_interaction_name: STEP_INTERACTION_NUDGE_DISPLAYED,
        trigger,
    });
}

function trackFavoritingNudgeDismissed({ trigger }: { trigger: ItemFavoritingNudgeTrigger }): void {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
        step_interaction_name: STEP_INTERACTION_NUDGE_DISMISSED,
        trigger,
    });
}

function trackSbSharedFavoritesNudgeContainerClicked({
    trigger,
}: {
    trigger: ItemFavoritingNudgeTrigger;
}): void {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
        step_interaction_name: STEP_INTERACTION_NUDGE_CLICKED,
        trigger,
    });
}

export {
    trackFavoritingNudgeDisplayed,
    trackFavoritingNudgeDismissed,
    trackSbSharedFavoritesNudgeContainerClicked,
    type ItemFavoritingNudgeTrigger,
};
